import gsap from 'gsap';

class Facts {
    constructor(element) {
        this.element = element;
        this.items = element.querySelectorAll('.dp-facts__item');
        this.interval = parseFloat(element.dataset.interval) || 4;
        this.currentIndex = 0;
        this.timer = null;
        this.isAnimating = false;

        if (this.items.length > 1) {
            this.init();
        }
    }

    init() {
        this.startAutoplay();
    }

    goTo(index) {
        if (index === this.currentIndex || this.isAnimating) return;

        this.isAnimating = true;

        const currentItem = this.items[this.currentIndex];
        const nextItem = this.items[index];

        const tl = gsap.timeline({
            onComplete: () => {
                this.isAnimating = false;
            }
        });

        tl.to(currentItem, {
            opacity: 0,
            duration: 0.5,
            ease: 'power1.out',
            onComplete: () => {
                currentItem.classList.remove('is-active');
            }
        });

        nextItem.classList.add('is-active');

        tl.fromTo(
            nextItem,
            { opacity: 0 },
            { opacity: 1, duration: 0.5, ease: 'power1.in' },
            '-=0.2'
        );

        this.currentIndex = index;
    }

    next() {
        const nextIndex = (this.currentIndex + 1) % this.items.length;
        this.goTo(nextIndex);
    }

    startAutoplay() {
        this.timer = setInterval(() => this.next(), this.interval * 1000);
    }
}

export function initFacts() {
    document.querySelectorAll('.dp-facts').forEach((el) => new Facts(el));
}

export default Facts;
